import { Component, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { BuyService } from '../../services/buyservice'
import { Location } from '@angular/common';
import { FirebaseApp } from 'angularfire2';

@Component({
  selector: 'app-detail-order',
  templateUrl: './detail-order.component.html',
  styleUrls: ['./detail-order.component.css']
})
export class DetailOrderComponent implements OnInit {

  idOrder
  detailItemOrder;
  checkDeli = false;
  image;

  ids;
  status;
  provinceCode='';
  constructor(private _location: Location, private firebaseApp: FirebaseApp, private zone: NgZone, private route: ActivatedRoute, public buy: BuyService, private router: Router) {
    // this.idOrder = route.snapshot.params['id'];
    this.route.params.subscribe(params => {
      this.ids = params['id'];
    })
    this.detailItemOrder = this.buy.OrderBuy(this.ids)
    if (this.detailItemOrder != null) {
      sessionStorage.setItem("is_reloaded_detailItem", JSON.stringify(this.detailItemOrder))
    }else{
      this.detailItemOrder = JSON.parse(sessionStorage.getItem("is_reloaded_detailItem"))
      
    }
    this.status = this.detailItemOrder.delivery;
    this.provinceCode = this.detailItemOrder.provinceCode;


    // console.log(this.detailItemOrder.id)
    //console.log(this.image)
    const storageRef = firebaseApp.storage().ref().child(`${this.detailItemOrder.confirmTransfer}`);
    storageRef.getDownloadURL().then((url) => {
      this.image = url
    });
  }

  ngOnInit() {
  }
  updateStatus(){
    this.buy.updateData(this.ids,this.status,this.provinceCode)
  }
  backClicked() {
    this._location.back();
  }
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/detail-order/detail-order.component.ts